<script lang="ts" setup>
import CustomModalWindow from '~/components/modal-windows/CustomModalWindow.vue'
import Page from '~/enums/page'
import helpers from '~/helpers'
import { useCartStore } from '~/store/cart'

const model = defineModel<boolean>()

const specialOfferPath = `${Page.SpecialOffers}otmechaem-4-goda-vmeste-s-lyubimymi-klientami-42/`

const cartStore = useCartStore()

function close (): void {
  model.value = false
}
</script>

<template>
  <CustomModalWindow v-model="model">
    <template #title>
      Золотые билеты
    </template>

    <p>За каждые {{ helpers.formatPrice(cartStore.goldenTicketStepAmountInKopecks, true) }}&nbsp;₽ в&nbsp;чеке вкладываем золотой билет. <a :href="specialOfferPath" target="_blank">Подробнее</a>.</p>

    <template #action>
      <a href="#" @click.prevent="close">Закрыть</a>
    </template>
  </CustomModalWindow>
</template>
